import { Loader2 } from 'lucide-react'
import { cn } from '../cn'

export function Spinner({ className }: { className?: string }) {
  return <Loader2 aria-hidden className={cn('size-4 animate-spin text-ink-faint', className)} />
}

export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden className={cn('animate-pulse rounded-[var(--radius-control)] bg-sunken', className)} />
}

/**
 * An empty screen is an invitation to act, so an action belongs here whenever
 * there is one the person can take.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon?: React.ComponentType<{ className?: string }>
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 px-6 py-16 text-center', className)}>
      {Icon ? (
        <span className="flex size-10 items-center justify-center rounded-full bg-sunken text-ink-faint">
          <Icon className="size-5" />
        </span>
      ) : null}
      <div className="space-y-1">
        <p className="text-md font-semibold text-ink">{title}</p>
        {description ? <p className="max-w-sm text-base text-ink-muted">{description}</p> : null}
      </div>
      {action}
    </div>
  )
}
